"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var SlideElements_1 = require("../../SlideElements");
var Content_1 = __importDefault(require("./Content"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Tournaments = function () {
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var data = (0, swr_hooks_1.useActiveTournaments)().data;
    var t = (0, next_intl_1.useTranslations)('translation');
    if (!(data === null || data === void 0 ? void 0 : data.length)) {
        return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container) },
            react_1.default.createElement(SlideElements_1.SliderInBanner, { containerClassName: styles_module_scss_1.default.sliderInBannerContainer },
                t('notAvailableTournaments'),
                '')));
    }
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container) }, (data === null || data === void 0 ? void 0 : data.length) && (react_1.default.createElement(SlideElements_1.SliderInBanner, { withNavigate: data.length > 1, containerClassName: styles_module_scss_1.default.sliderInBannerContainer }, data.map(function (tournament) {
        var _a, _b, _c;
        return (react_1.default.createElement(react_1.default.Fragment, { key: tournament.id },
            react_1.default.createElement(Content_1.default, { title: translateLocale((_a = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _a === void 0 ? void 0 : _a.name), description: translateLocale((_c = (_b = tournament === null || tournament === void 0 ? void 0 : tournament.baseTournament) === null || _b === void 0 ? void 0 : _b.descriptions) === null || _c === void 0 ? void 0 : _c.short), endDate: tournament === null || tournament === void 0 ? void 0 : tournament.endDate, id: tournament === null || tournament === void 0 ? void 0 : tournament.id, me: tournament === null || tournament === void 0 ? void 0 : tournament.me, isFinished: false })));
    })))));
};
exports.default = Tournaments;
